import React from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import AccountCircle from '@material-ui/icons/AccountCircle';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';

import { Link as RouterLink, Redirect } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    grow: {
      flexGrow: 1,
    },
    fullWidth: {
        width: '100%'
    },
    largeIcon: {
        '& .MuiSvgIcon-fontSizeLarge': {
            fontSize: '2.8rem'
        }
    }
}));

export default function CoupleAppBar(props) {
    const {
        couple,
        editing
    } = props;
    const classes = useStyles();
    const menuId = 'primary-menu';
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleProfileMenuOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogoutClick = () => {
        const form = document.getElementById('logout-form');
        form.submit();
        handleMenuClose();
        <Redirect to="/" />
    }

    const isMenuOpen = Boolean(anchorEl);

    const isOfficiantOrAnyAdminRole = window.isOfficiantOrAnyAdminRole;

    const MenuLink = React.forwardRef((props, ref) => <RouterLink innerRef={ref} {...props} />);

    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={menuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem component={MenuLink} to="/couple" onClick={handleMenuClose}>Create Your Ceremony</MenuItem>
            <MenuItem component={MenuLink} to="/couple/profile" onClick={handleMenuClose}>Profile</MenuItem>
            <MenuItem component={MenuLink} to="/couple/balance" onClick={handleMenuClose}>Balance</MenuItem>
            <MenuItem component={MenuLink} to="/couple/instructions" onClick={handleMenuClose}>Instructions</MenuItem>
            <Box py={1}>
                <Divider />
            </Box>
            {isOfficiantOrAnyAdminRole &&
                <MenuItem>
                    <Link href="/admin" color="inherit" className={classes.fullWidth} underline="none">Admin Home</Link>
                </MenuItem>
            }
            {isOfficiantOrAnyAdminRole &&
                <Box py={1}>
                    <Divider />
                </Box>
            }
            <Tooltip title={editing ? "You have unsaved changes to the ceremony" : ""}>
                <span>
                    <MenuItem disabled={editing} onClick={handleLogoutClick}>Logout</MenuItem>
                </span>
            </Tooltip>
        </Menu>
    );

    return (
        <div>
            <Grid
                container
                direction="row"
                justify="space-evenly"
                alignItems="center"
            >
                <div className={classes.grow} />
                <Grid item className={classes.grow} align="center">
                    <Typography>
                        <Link component={MenuLink} to="/couple">
                            <img
                                src="/img/ep-logo-sm-v2.png"
                                style={{
                                    maxWidth: '240px',
                                    marginLeft: '50px',
                                }}
                            />
                        </Link>
                    </Typography>
                </Grid>
                <Grid item className={classes.grow} align="center">
                    <IconButton
                            edge="end"
                            aria-label="account of current user"
                            aria-controls={menuId}
                            aria-haspopup="true"
                            color="primary"
                            onClick={handleProfileMenuOpen}
                            className={classes.largeIcon}
                        >
                            <AccountCircle fontSize="large" />
                    </IconButton>
                </Grid>
            </Grid>
            {renderMenu}
        </div>
    );
};
